import React, { useEffect, useMemo } from 'react';
import { easepick } from '@easepick/core';
import { RangePlugin } from '@easepick/range-plugin';
import { getRandomSmallString } from 'src/utils/strings';

const DatePickerRange = ({ onDatesChange, initialStartDate, initialEndDate, className = '', setOpen, children }) => {
    const randomId = useMemo(() => `datepicker-${getRandomSmallString()}`, []);

    useEffect(() => {
        const datepickerObject = new easepick.create({
            element: `#${randomId}`,
            css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css', '/styles/DatePickerRange.css'],
            zIndex: 10,
            plugins: [RangePlugin],
            RangePlugin: {
                startDate: initialStartDate,
                endDate: initialEndDate,
            },
        });
        datepickerObject.on('select', (e) => {
            onDatesChange(e.detail.start, e.detail.end);
        });
        if (setOpen) {
            datepickerObject.on('view', (e) => {
                setOpen(datepickerObject.isShown());
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <label className={`flex cursor-pointer ${className}`}>
            {children}
            <input id={randomId} className="w-full h-0 w-0" />
        </label>
    );
};

export default DatePickerRange;
